export const hasDeposit = ({ depositAmount, paidAmount, }) => {
    return !!depositAmount && depositAmount - paidAmount > 0;
};
//# sourceMappingURL=hasDeposit.js.map